import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  GET_ITEMWISE_SALE_LIST,
  GET_TOP_PRODUCT_SOLD,
} from "../../../../Constants/Config";

const initialState = {
  loading: false,
  ItemSalesData: [],
  GetTopProductSold: [],
  successMessage: "",
  error: "",
};
let controller = null;
// Generate pening , fulfilled and rejected action type
export const fetchItemSalesData = createAsyncThunk(
  "ItemSalesSlice/fetchItemSalesData.",
  async (data, { rejectWithValue }) => {
    if (controller) {
      controller.abort();
    }

    // Create a new AbortController instance for the current request
    controller = new AbortController();

    try {
      const { token, ...dataNew } = data;

      const response = await axios.post(
        BASE_URL + GET_ITEMWISE_SALE_LIST,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        }
      );
      if (response.data.status == true) {
        // return response.data.item_sale_data

        return [
          // response.data?.item_data,
          response.data.item_sale_data,
          response.data.net_sale,
          response.data.total_sold,
          response.data.status,
        ];
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
        return;
      }
      // throw new Error(error.response.data.message);
      const customError = {
        message: error.message,
        status: error.response ? error.response.status : "Network Error",
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

// TOP PRODUCT SOLD-------------------
export const fetchTopProductSold = createAsyncThunk(
  "ItemSalesSlice/fetchTopProductSold",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;

      const response = await axios.post(
        BASE_URL + GET_TOP_PRODUCT_SOLD,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.status == true) {
        // return response.data.item_sale_data

        return [
          response.data?.item_data,
          // response.data.item_sale_data,
          response.data.net_sale,
          response.data.total_sold,
          response.data.status,
        ];
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: error.message,
        status: error.response ? error.response.status : "Network Error",
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
// TOP PRODUCT SOLD-------------------
const ItemSalesSlice = createSlice({
  name: "ItemSalesSlice",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchItemSalesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchItemSalesData.fulfilled, (state, action) => {
      state.loading = false;
      state.ItemSalesData = action.payload;
      state.error = "";
    });
    builder.addCase(fetchItemSalesData.rejected, (state, action) => {
      state.loading = false;
      state.ItemSalesData = {};
      state.error = action.error.message;
    });
    // ----------fetch top product sold--------
    builder.addCase(fetchTopProductSold.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTopProductSold.fulfilled, (state, action) => {
      state.loading = false;
      state.GetTopProductSold = action.payload;
      state.error = "";
    });
    builder.addCase(fetchTopProductSold.rejected, (state, action) => {
      state.loading = false;
      state.GetTopProductSold = {};
      state.error = action.error.message;
    });
    // ----------fetch top product sold--------
  },
});

export default ItemSalesSlice.reducer;
